import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

// Was: searchQuery/selectedCategory lived in CartContext, which is consumed
// by 13+ components across the PoS screen (NavBar, Header, Cart, CartTable,
// CartSummary, CommissionDialog, ...). CartContext's value can't safely be
// memoized (its cart/money functions close over state and aren't
// useCallback-stable), so every single keystroke in the item search box
// re-rendered all 13+ of them - not just the 3 that actually care about
// search/category (AppBarComp, ItemCards, FloatingFooter). Moving this
// narrow, fast-changing state into its own small memoized context stops
// that fan-out without touching any cart/money logic.
const ItemSearchContext = createContext();

export const useItemSearch = () => useContext(ItemSearchContext);

export function ItemSearchProvider({ children }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);

  const filterItemsByCategory = useCallback((category) => {
    setSelectedCategory(category);
    setSearchQuery("");
  }, []);

  const value = useMemo(
    () => ({
      searchQuery,
      setSearchQuery,
      selectedCategory,
      setSelectedCategory,
      filterItemsByCategory,
    }),
    [searchQuery, selectedCategory, filterItemsByCategory]
  );

  return (
    <ItemSearchContext.Provider value={value}>
      {children}
    </ItemSearchContext.Provider>
  );
}
